export default "__VITE_ASSET__BHjyW9Pv__"